import { baseTheme } from '~base-theme';
var alertTheme = {
  alert: {
    alertFeedback: {
      icon: {
        size: 40
      },
      backgroundColor: baseTheme.base.colors.light
    }
  }
};
export default alertTheme;